// = Libs =
import { SWRConfiguration } from 'swr';

// = Constants =
import { API_INSTANCE_SWR } from '@/constants/api';

const SWR_CONFIG: SWRConfiguration = {
  fetcher: (url: string) => API_INSTANCE_SWR.get(url).then((res) => res.data),
  shouldRetryOnError: false,
  refreshWhenHidden: true,
  refreshWhenOffline: true,
};

export default SWR_CONFIG;
